import {
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Menu,
    MenuItem,
    Avatar,
    Box,
    Button,
    useTheme,
    useMediaQuery
} from '@mui/material';
import { Menu as MenuIcon, AccountCircle } from '@mui/icons-material';
import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate, useLocation } from 'react-router-dom';

const Header = ({ sidebarOpen, onMenuClick }) => {
    const { user, logout } = useAuth();
    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isEntryPassPage = location.pathname === '/entry-pass';
    const isProtectedRoute = user && location.pathname !== '/login';
    const showMenuButton = isProtectedRoute && (isMobile || isEntryPassPage);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleProfile = () => {
        handleClose();
        navigate('/profile');
    };

    const handleLogout = () => {
        handleClose();
        logout();
    };

    return (
        <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, borderRadius: 0 }}>
            <Toolbar>
                {showMenuButton && (
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={onMenuClick}
                        edge="start"
                        sx={{ mr: 2 }}
                    >
                        <MenuIcon />
                    </IconButton>
                )}
                <Typography 
                    variant="h6" 
                    component="div" 
                    sx={{ 
                        flexGrow: 1,
                        cursor: 'pointer',
                        ml: !showMenuButton ? 2 : 0,
                        whiteSpace: 'nowrap',
                        fontSize: {
                            xs: '0.9rem',
                            sm: '1.25rem'
                        },
                        fontWeight: 700,
                        letterSpacing: '0.06em',
                        textTransform: 'uppercase',
                        fontFamily: '"Oswald", "Impact", sans-serif',
                        textShadow: '1px 1px 2px rgba(0,0,0,0.1)'
                    }}
                    onClick={() => navigate(user ? '/dashboard' : '/')}
                >
                    Total Turf Experience
                </Typography>

                {!user ? (
                    // Public navigation
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <Button 
                            color="inherit" 
                            onClick={() => navigate('/faq')}
                        >
                            FAQ
                        </Button>
                        <Button 
                            color="inherit"
                            variant="outlined"
                            onClick={() => navigate('/login')}
                            sx={{ borderColor: 'white' }}
                        >
                            Login
                        </Button>
                    </Box>
                ) : (
                    // User menu
                    <Box>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleMenu}
                            color="inherit"
                        >
                            <AccountCircle />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            <MenuItem onClick={handleProfile}>Profile</MenuItem>
                            <MenuItem onClick={handleLogout}>Logout</MenuItem>
                        </Menu>
                    </Box>
                )}
            </Toolbar>
        </AppBar>
    );
};

export default Header; 